<script lang="ts">
  import { Tween, type TweenedOptions } from 'svelte/motion';
  import { quintInOut } from 'svelte/easing';
  import type {AcademicState} from '../imports/builders/buildAcademic.svelte';

  import MiniPercentage from './MiniPercentage.svelte';

  let {
    dashboardState,
  }:{
    dashboardState: AcademicState
  } = $props();

  const tweenedPercentage = new Tween(0.0, {
    delay: 1000,
    duration: 2000,
    easing: quintInOut,
  });
  
  $effect(()=> {
    tweenedPercentage.set(Number(dashboardState.percentChange));
  });
</script>

<MiniPercentage title="% change" value={tweenedPercentage.current} polarity={dashboardState.percentChangePolarity ?? 'positive'} />